import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const poreportsApi = api.injectEndpoints({
  endpoints: builder => ({
    getPOReports: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/cashier/${cid}/${fdt}/${tdt}`
    }),
    getPOOrders: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/orders/${cid}/${fdt}/${tdt}`
    }),
    getPOSumm: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/cashiersumm/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsWaiterWise: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/waiterwise/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsItemWise: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/itemwise/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsItemWaiterWise: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `poreports/itemwaiterwise/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsOrder: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/order/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsOrderNC: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/ordernc/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsOrderNCBill: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/orderncbill/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsCashClose: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/cashclose/${cid}/${fdt}/${tdt}`
    }),
    getPOReportsGroupWise: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `poreports/groupwise/${cid}/${fdt}/${tdt}`
    }),
    getPOIssues: builder.query<any, any>({
      query: ({ cid, olid, fdt, tdt }) =>
        `poreports/issue/${cid}/${olid}/${fdt}/${tdt}`
    }),
    getPOStocks: builder.query<any, any>({
      query: ({ cid, olid, fdt, tdt }) =>
        `poreports/stock/${cid}/${olid}/${fdt}/${tdt}`
    }),
    getPOCancelOrders: builder.query<any, any>({
      query: ({ cid, olid, fdt, tdt }) =>
        `poreports/cancelorders/${cid}/${olid}/${fdt}/${tdt}`
    }),
    resetPrinting: builder.mutation<any, any>({
      query: ({ type, id }) => ({
        url: `poreports/resetprinting/${type}/${id}`,
        method: 'PUT'
      })
    })
  }),
  overrideExisting: false
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOReportsQuery,
  useGetPOOrdersQuery,
  useGetPOSummQuery,
  useLazyGetPOSummQuery,
  useGetPOReportsWaiterWiseQuery,
  useGetPOReportsItemWiseQuery,
  useGetPOReportsItemWaiterWiseQuery,
  useGetPOReportsOrderQuery,
  useGetPOReportsOrderNCQuery,
  useGetPOReportsOrderNCBillQuery,
  useGetPOReportsCashCloseQuery,
  useGetPOReportsGroupWiseQuery,
  useGetPOIssuesQuery,
  useGetPOStocksQuery,
  useGetPOCancelOrdersQuery,
  useResetPrintingMutation
} = poreportsApi;

